import classNames from 'classnames';
import { ForwardedRef } from 'react';

import ToggleIcon from '../icons/ToggleIcon';
import BasicButton, { BasicButtonElement, BasicButtonProps } from './BasicButton';

import styles from '../../styles/buttons/toggle-button.module.css';

export interface ToggleButtonProps extends Omit<BasicButtonProps, 'onClick'> {
    value?: boolean;
    loading?: boolean;
    onChange?: ((value: boolean) => void) | null;
}

function ToggleButton({
    value = false,
    loading = false,
    className = null,
    onChange = null,
    ref: buttonRef = null,
    ...props
}: ToggleButtonProps & { ref?: ForwardedRef<BasicButtonElement> | null }) {
    const onClick = () => {
        if (onChange !== null) {
            onChange(!value);
        }
    };

    return (
        <BasicButton
            ref={buttonRef}
            className={classNames([styles.container, className])}
            {...props}
            onClick={onClick}
        >
            <ToggleIcon checked={value} loading={loading} className={styles.toggle} />
        </BasicButton>
    );
}

export default ToggleButton;
